module.exports = __webpack_public_path__ + "media/how_fastweb_works/today_logo_01-20f2ee1c.png";